import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated" 
import { getID } from "src/libs/utilities"

export default function passage (): any[] {
    return [
        {
            id: getID("passage"),
            animated : ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            items: [
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/a2/4d/1c/a24d1cbaaa49800e440412729871d800.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/d8/27/2a/d8272a5f65eac1c2bd1f0be995396cf1.jpg",  
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/fb/21/95/fb21959f074de6093bf4d2e636cd7156.jpg",  
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/91/38/10/913810950142f979ca695e97553c919f.jpg",  
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/b6/11/fc/b611fc5a7d1e354deeb7188b7327feaf.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/93/f3/40/93f34046f2ab6dd40aacb3e140f567ec.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/7f/ee/d3/7feed349e437205a2bf9046182efe8cb.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/33/26/f7/3326f77220f5a4d0d671e34cd497e5ec.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/fd/e7/53/fde753242a621371a68ed02d267a785b.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/63/ca/d0/63cad03bd62ce326abc467999786a900.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/736x/6b/c9/f7/6bc9f76b23712af66d489973c2bfc24d.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/35/57/21/355721a0030000a6f14ccae3b0a0690f.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/94/01/4f/94014f0a4d8bc8c4f7a4ed346703d44b.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/a4/d1/05/a4d105ac5b510d3e4f774327186622e7.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/69/2f/9d/692f9d74af07842c575b102fc9715334.jpg", 
                },
                {
                    id: getID("image"), 
                    "src": "https://i.pinimg.com/1200x/bd/f7/bc/bdf7bcbbe58dc21fedd9080a622d976f.jpg", 
                    "src_type": "src",
                },
            ],
            columns: 4,
            itemHeight: 250,
            passageType: "synchronous",
            gap: 10,
            src_type: "src",
            defaultTitle: "Равномерный пассаж",
            defaultDescription: "Все изображения одного размера",
        },
        {
            id: getID("passage"),
            animated : ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            items: [
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/a2/4d/1c/a24d1cbaaa49800e440412729871d800.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/d8/27/2a/d8272a5f65eac1c2bd1f0be995396cf1.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/fb/21/95/fb21959f074de6093bf4d2e636cd7156.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/91/38/10/913810950142f979ca695e97553c919f.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/b6/11/fc/b611fc5a7d1e354deeb7188b7327feaf.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/93/f3/40/93f34046f2ab6dd40aacb3e140f567ec.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/7f/ee/d3/7feed349e437205a2bf9046182efe8cb.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/33/26/f7/3326f77220f5a4d0d671e34cd497e5ec.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/fd/e7/53/fde753242a621371a68ed02d267a785b.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/63/ca/d0/63cad03bd62ce326abc467999786a900.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/6b/c9/f7/6bc9f76b23712af66d489973c2bfc24d.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/35/57/21/355721a0030000a6f14ccae3b0a0690f.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/94/01/4f/94014f0a4d8bc8c4f7a4ed346703d44b.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/a4/d1/05/a4d105ac5b510d3e4f774327186622e7.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/69/2f/9d/692f9d74af07842c575b102fc9715334.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/1200x/bd/f7/bc/bdf7bcbbe58dc21fedd9080a622d976f.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/74/5c/42/745c42177e4b04093243f126ba74ef8d.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/4e/b7/a7/4eb7a79bfdbc402b041cc852870749eb.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
                {
                    id: getID("image"),
                    "type": "image",
                    "src": "https://i.pinimg.com/736x/f3/7a/22/f37a227dfe5847a3c775fd09787c1bd7.jpg",
                    "src_type": "src",
                    "height": "auto", 
                },
            ],
            columns: 4,
            itemHeight: 350,
            src_type: "src",
            passageType: "horizontal",
            gap: 0,
            defaultTitle: "Пассаж",
            defaultDescription: "Всё в ленту",
        },
        {
            "id": getID("passage"),
            animated : ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "items": [
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/a2/4d/1c/a24d1cbaaa49800e440412729871d800.jpg"  
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/f3/7a/22/f37a227dfe5847a3c775fd09787c1bd7.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/fb/21/95/fb21959f074de6093bf4d2e636cd7156.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/d8/27/2a/d8272a5f65eac1c2bd1f0be995396cf1.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/91/38/10/913810950142f979ca695e97553c919f.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/b6/11/fc/b611fc5a7d1e354deeb7188b7327feaf.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/93/f3/40/93f34046f2ab6dd40aacb3e140f567ec.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/7f/ee/d3/7feed349e437205a2bf9046182efe8cb.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/33/26/f7/3326f77220f5a4d0d671e34cd497e5ec.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/fd/e7/53/fde753242a621371a68ed02d267a785b.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/63/ca/d0/63cad03bd62ce326abc467999786a900.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/6b/c9/f7/6bc9f76b23712af66d489973c2bfc24d.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/35/57/21/355721a0030000a6f14ccae3b0a0690f.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/94/01/4f/94014f0a4d8bc8c4f7a4ed346703d44b.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/a4/d1/05/a4d105ac5b510d3e4f774327186622e7.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/69/2f/9d/692f9d74af07842c575b102fc9715334.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/1200x/bd/f7/bc/bdf7bcbbe58dc21fedd9080a622d976f.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/74/5c/42/745c42177e4b04093243f126ba74ef8d.jpg", 
            },
            {
              "id": getID("image"), 
              "src": "https://i.pinimg.com/736x/4e/b7/a7/4eb7a79bfdbc402b041cc852870749eb.jpg", 
            }
          ],
          "columns": 6, 
          "src_type": "src",
          "passageType": "masonry",
          "gap": 20,
          "hover_size": 5,
          "defaultTitle": "Пассаж-водопад", 
        },
        {
            "id": getID("passage"),
            animated : ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            "items": [ 
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/1f/5f/91/1f5f91665570b0c21f9570fb0ba3a8d8.jpg",
                    "link_url": ""
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/c5/95/bc/c595bc7021a3a1e88f5a32c82ee032b0.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/9b/0f/65/9b0f655138305ddf5e7cfdfe7b5fca6a.jpg",
                    "link_url": "https://ru.pinterest.com/pin/10836855347345615/"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/4a/63/b9/4a63b977bc1ad187e4fd99cf49dbae8e.jpg",
                    "link_url": "https://ru.pinterest.com/pin/6051780746134261/"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/c1/41/92/c14192feef19219c6449eca57c2074c0.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/29/5e/e3/295ee3d5158f8fa6c004eaf5f0a4b685.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/98/e5/9d/98e59d5b5c17c19e3301d2aac8ba2ee5.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/94/3f/5c/943f5c1c503df437c1612bf7e4a4b908.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/92/69/cb/9269cbd9fa7a05fe64e52394b7dd7727.jpg",
                    "link_url" : "https://ru.pinterest.com/pin/2392606048677831/"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/19/20/29/192029a5147320ca1ffd9371d5b4a7ac.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/97/14/9b/97149b6cc5e20ec4336207edd874881d.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/c6/c6/fb/c6c6fbdc01f0f81b46557d8d9a6fefae.jpg",
                    "link_url": "https://ru.pinterest.com/pin/15058979995920293/"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/59/30/09/593009e3bc816f48f39bf78b7435ed98.jpg",
                    "link_url": "https://ru.pinterest.com/pin/4644405861005819/"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/47/e9/38/47e938143adf7030841800904ff1cb1a.jpg",
                    "link_url": "https://ru.pinterest.com/pin/28077197672261417/"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/736x/24/c0/ef/24c0ef512d5464703c1810e1b79da558.jpg"
                },
                {
                    id: getID("image"),
                    "src": "https://i.pinimg.com/1200x/97/ae/93/97ae93e53493b01cf4cae0da454e867c.jpg",
                    "link_url": "https://ru.pinterest.com/pin/70437490580685/"
                }
          
            ],
            "columns": 4, 
            "passageType": "square",
            "gap": 3,
            border: {
                borderWidth: 0,
                borderStyle: "solid",
                borderColor: "var(--force-contast-color)",
                borderRound: 30,
            },
            "src_type": "src",
            "defaultTitle": "Квадратные рамки", 
        }
    ]
}